import React from 'react'
import ClassNames from 'classnames'
import { MainLayoutStyled } from './styled'

import { Section } from '../../components/Section'

export class MainLayoutContainer extends React.Component {
  render() {
    const { children, className } = this.props

    return (
      <MainLayoutStyled className={ClassNames('main-layout', className)}>
        <Section className="main-wrapper">{children}</Section>
      </MainLayoutStyled>
    )
  }
}
